import { useState, useEffect } from 'react'
import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap'
import styles from './filter_group.module.css'

export const FilterGroup = ({
  children,
  className = '',
  showResetFilters = false,
  onResetFilters = () => {},
  maxButtonsPerRow = 3,
}) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    const childrenArray = Array.isArray(children) ? children : [children]
    const chunked = []
    for (let i = 0; i < childrenArray.length; i += maxButtonsPerRow) {
      chunked.push(childrenArray.slice(i, i + maxButtonsPerRow))
    }
    setRows(chunked)
  }, [children, maxButtonsPerRow])

  return (
    <div className={`flex-fill flex-md-grow-0 flex-md-shrink-0 ${styles.filter_group} ${className}`}>
      <ButtonToolbar className="flex-wrap" style={{ gap: '0.25rem' }} aria-label="Filter toolbar">
        {rows.map((rowChildren, i) => {
          const isLastRow = i === rows.length - 1
          return (
            <ButtonGroup key={i} aria-label={`Filter row ${i}`} className="mb-1">
              {/* Bottone filtro sempre all'inizio */}
              <Button type="button" className="px-1" style={{ maxWidth: '2rem' }} aria-label="Filtra">
                <i className="fas fa-filter fa-nowidth" />
              </Button>

              {/* Bottoni figli della riga */}
              {rowChildren}

              {/* Reset solo nell'ultima riga, attaccato all'ultimo children */}
              {showResetFilters && isLastRow && (
                <Button
                  type="button"
                  className="px-1"
                  style={{ maxWidth: '2rem', backgroundColor: '#494d4e', borderColor: '#494d4e' }}
                  onClick={onResetFilters}
                  aria-label="Reset filtri">
                  <i className="fas fa-times text-danger fa-nowidth" />
                </Button>
              )}
            </ButtonGroup>
          )
        })}
      </ButtonToolbar>
    </div>
  )
}

FilterGroup.displayName = 'FilterGroup'

export default FilterGroup
